import { RESET_SELECTED_ROWS, TOGGLE_ALL_ROWS, TOGGLE_ROW } from "../actions/SelectedRows";

const initialState = {
   selectedRowIds: [],
};

const selectedRows = (state = initialState, action) => {
   switch (action.type) {
      case TOGGLE_ROW: {
         const { rowId, checked } = action.payload;
         if (checked) {
            return {
               ...state,
               selectedRowIds: state.selectedRowIds.includes(rowId)
                  ? state.selectedRowIds
                  : [...state.selectedRowIds, rowId],
            };
         } else {
            return { ...state, selectedRowIds: state.selectedRowIds.filter((id) => id !== rowId) };
         }
      }
      case TOGGLE_ALL_ROWS: {
         const { rowIds, checked } = action.payload;
         if (checked) {
            return {
               ...state,
               selectedRowIds: Array.from(new Set([...state.selectedRowIds, ...rowIds])),
            };
         } else {
            return {
               ...state,
               selectedRowIds: state.selectedRowIds.filter((id) => !rowIds.includes(id)),
            };
         }
      }
      case RESET_SELECTED_ROWS:
         return { ...state, selectedRowIds: [] };
      default:
         return state;
   }
};

export default selectedRows;
